import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              常见<span className="text-primary-600">问题</span>
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              关于久久在线，您可能想了解的信息
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                    openIndex === index ? 'bg-primary-100 text-primary-600 rotate-45' : 'bg-background-100 text-foreground-500'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}